import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createPlant } from '../../api/production-request-api/index.js';
import { toast } from '@pella/sash-framework';
import { QUERY_KEYS } from '../../data/constants';

/**
 * Hook containing mutation function for creating a Plant.
 */
export const useCreatePlant = () => {
  const queryClient = useQueryClient();

  return useMutation({
    /**
     * mutateFn - Function to call createPlant.
     * @param {Pella.ProductionRequestAPI.CreatePlantInput} input - The inputs for creating the Plant.
     */
    mutationFn: (input) => createPlant(input),
    onSuccess: () => {
      toast.success('Plant created successfully!');
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.PLANT_DATA] });
    },
  });
};
